import React from 'react'
import { PieChart, BarChart } from 'react-chartkick'
import 'chart.js'

export const PieCharts = () => (        //shortcut to not type a return
    <div>
        <h1>Cryptocurrency Data</h1>

        <div>
            <br></br>
            <h4>Top 25 Coins: Market Caps</h4>
        <PieChart width ="800px" height ="500px" thousands = "," download="WOWPIE" data={[
            ["BTC", 131589130518.68], ["ETH", 15909002056.58], ["XRP", 9662635218.30], ["USDT", 4127361972.19], ["BCH", 3766401441.97], ["LTC", 2830306774.79], ["EOS", 2465894316.28], 
            ["BNB", 2312044247.93], ["BSV", 1733606736.15], ["XLM", 1078040311.76], ["XTZ", 987711724.34], ["ADA", 950947378.08], ["TRX", 943040057.09], ["XMR", 917581547.95],
            ["LEO", 902004068.69], ["LINK", 777795698.89], ["ATOM", 683162523.71], ["HT", 653850692.31], ["NEO", 604332902.09], ["IOTA", 553145068.68],["MKR", 502695440.36], ["USDC", 481376314.86], 
            ["DASH", 462737443.16], ["ETC", 439204658.30], ["ONT", 373703179.98]
                    ]}
                         />
            <br></br>
            <BarChart width ="800px" height ="500px" thousands = "," download="WOWCHOCOBARS" data={[
            ["BTC", 131589130518.68], ["ETH", 15909002056.58], ["XRP", 9662635218.30], ["USDT", 4127361972.19], ["BCH", 3766401441.97], ["LTC", 2830306774.79], ["EOS", 2465894316.28], 
            ["BNB", 2312044247.93], ["BSV", 1733606736.15], ["XLM", 1078040311.76], ["XTZ", 987711724.34], ["ADA", 950947378.08], ["TRX", 943040057.09], ["XMR", 917581547.95],
            ["LEO", 902004068.69], ["LINK", 777795698.89], ["ATOM", 683162523.71], ["HT", 653850692.31], ["NEO", 604332902.09], ["IOTA", 553145068.68],["MKR", 502695440.36], ["USDC", 481376314.86], 
            ["DASH", 462737443.16], ["ETC", 439204658.30], ["ONT", 373703179.98]
                    ]}
                         />
        </div>
       
    </div>
)